<template>
  <div class="permission-item">
    <div class="permission-name">
      <span class="mr-2">{{ label }}</span>
      <TooltipIcon
        color="accent"
        icon="mdi-information"
        :icon-size="20"
        v-if="tooltip"
      >
        {{ tooltip }}
      </TooltipIcon>
    </div>
    <div class="permission-value">
      <v-checkbox v-model="permission" v-if="!readonly" />
      <div class="value-icon" v-else>
        <v-icon size="24" color="primary" v-if="permission">icon-check</v-icon>
        <v-icon size="24" color="text" v-else class="muted">icon-close</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import TooltipIcon from "@/components/ui/TooltipIcon";
import { RELATION } from "@/enums/permissions-relation";

export default {
  name: "PermissionItem",
  components: {
    TooltipIcon
  },
  props: {
    name: {
      type: String,
      required: false
    },
    readonly: Boolean,
    relatedPermission: {
      type: Array,
      required: false
    }
  },
  computed: {
    permission: {
      get() {
        return this.$store.getters["permissions/permission"](this.name);
      },
      set(value) {
        if (this.relatedPermission) {
          this.relatedPermission.forEach(permission => {
            if (permission.relation == RELATION.PARENT && value) {
              this.$store.dispatch("permissions/setPermission", {
                key: permission.name,
                value
              });
            }
            if (permission.relation == RELATION.CHILD && !value) {
              this.$store.dispatch("permissions/setPermission", {
                key: permission.name,
                value
              });
            }
          });
        }
        this.$store.dispatch("permissions/setPermission", {
          key: this.name,
          value
        });
      }
    },
    label() {
      return this.$t(`message.permissionsData.name.${this.name}`);
    },
    tooltip() {
      const i18nKey = `message.permissionsData.tooltip.${this.name}`;
      return this.$te(i18nKey) ? this.$t(i18nKey) : null;
    }
  }
};
</script>

<style lang="scss">
.permission-item {
  min-height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba($light-3, 0.5);

  .permission-name {
    font-weight: 500;
    @include font-size(14px);
    line-height: 17px;
    color: $text;
    display: flex;
    align-items: center;
  }

  .value-icon,
  .v-input--selection-controls__input {
    margin-right: $spacing * 1.5;
  }

  .muted {
    opacity: 0.4;
  }
}
</style>
